"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logo = exports.wrapper = void 0;

var _util = require("../../../util");

const wrapper = ({
  theme,
  cssProps: {
    width
  }
}) => ({
  width,
  border: "1px solid ".concat((0, _util.color)(theme, 'ui4')),
  boxSizing: 'border-box',
  borderRadius: 12,
  padding: (0, _util.spacing)(theme, 24),
  cursor: 'pointer'
});

exports.wrapper = wrapper;

const logo = () => ({
  width: 56,
  height: 56,
  borderRadius: 8
});

exports.logo = logo;
//# sourceMappingURL=QuarterlyReportCard.style.js.map